import { render } from "./GuideTarget.vue?vue&type=template&id=8c5be320&ts=true"
import script from "./GuideTarget.vue?vue&type=script&lang=ts"
export * from "./GuideTarget.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__